import axios from "axios";

const BACKEND_ORIGIN = (process.env.REACT_APP_BACKEND_URL || "https://shuletaki.com.tr").replace(/\/+$/, "");

const api = axios.create({
  baseURL: `${BACKEND_ORIGIN}/api`,
  timeout: 15000,
  withCredentials: true,
});

// A Pages/SPA fallback can return HTTP 200 HTML even when the API is unavailable.
// Reject it before account, form or payment callers can interpret it as success.
api.interceptors.response.use((response) => {
  if (response.data === null || typeof response.data !== "object") {
    throw new Error("Hizmetten geçerli API yanıtı alınamadı. İşlem tamamlanmadı; tekrar deneyebilirsiniz.");
  }
  return response;
});

function requireList(response) {
  if (!Array.isArray(response.data)) {
    throw new Error("API liste yanıtı beklenirken farklı içerik alındı");
  }
  return response.data;
}

export const getCategories = () => api.get("/categories").then(requireList);
export const getCampaigns = () => api.get("/campaigns").then(requireList);
export const getProducts = (params = {}) => api.get("/products", { params }).then(requireList);
export const askStyleAssistant = (payload, signal) => api.post("/assistant/chat", payload, {timeout:35000, signal, withCredentials:false}).then(r=>{
  if(typeof r.data.answer!=="string"||!Array.isArray(r.data.products)||!Array.isArray(r.data.links))throw Error("Geçersiz asistan yanıtı.");
  return r.data;
});
export const getProduct = (slug) => api.get(`/products/${slug}`).then((r) => r.data);
export const getCollections = () => api.get("/collections").then(requireList);
export const getCollection = (slug) => api.get(`/collections/${slug}`).then((r) => r.data);
export const getLocations = (params = {}) => api.get("/locations", { params }).then(requireList);
export const postSubscriber = (payload) => api.post("/subscribers", payload).then((r) => r.data);
export const postLead = (payload) => api.post("/leads", payload).then((r) => r.data);
export const postContact = (payload) => api.post("/contact", payload).then((r) => r.data);

export const authMe = () => api.get("/auth/me").then((r) => r.data);
export const getServerFavorites = () => api.get("/auth/favorites").then((r) => r.data);
export const putServerFavorites = (favorites) => api.put("/auth/favorites", { favorites }).then((r) => r.data);
export const forgotPassword = (email) => api.post("/auth/forgot-password", { email }).then((r) => r.data);
export const resetPassword = (payload) => api.post("/auth/reset-password", payload).then((r) => r.data);
export const getMyOrders = () => api.get("/orders").then((r) => r.data);
export const getAddresses = () => api.get("/auth/addresses").then((r) => r.data);
export const addAddress = (payload) => api.post("/auth/addresses", payload).then((r) => r.data);
export const deleteAddress = (id) => api.delete(`/auth/addresses/${id}`).then((r) => r.data);
export const getAdminOverview = () => api.get("/admin/overview").then((r) => r.data);
export const getAdminOrders = () => api.get("/admin/orders").then((r) => r.data);
export const getAdminLeads = () => api.get("/admin/leads").then((r) => r.data);
export const getAdminSubscribers = () => api.get("/admin/subscribers").then((r) => r.data);
export const getAdminMessages = () => api.get("/admin/messages").then((r) => r.data);
export const getAdminProducts = () => api.get("/admin/products").then((r) => r.data);
export const patchAdminProduct = (slug, payload) => api.patch(`/admin/products/${slug}`, payload).then((r) => r.data);
export const getAdminCampaigns = () => api.get("/admin/campaigns").then((r) => r.data);
export const createCampaign = (payload) => api.post("/admin/campaigns", payload).then((r) => r.data);
export const updateCampaign = (slug, payload) => api.put(`/admin/campaigns/${slug}`, payload).then((r) => r.data);
export const deleteCampaign = (slug) => api.delete(`/admin/campaigns/${slug}`).then((r) => r.data);
export const uploadProductImage = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return api.post("/admin/upload", fd).then((r) => r.data);
};
export const refundOrder = (sessionId) => api.post(`/admin/orders/${sessionId}/refund`).then((r) => r.data);
export const patchOrderStatus = (sessionId, fulfillment_status) =>
  api.patch(`/admin/orders/${sessionId}`, { fulfillment_status }).then((r) => r.data);
export const markOrderPaid = (sessionId) =>
  api.patch(`/admin/orders/${sessionId}`, { mark_paid: true }).then((r) => r.data);
export const fileUrl = (path) => `${BACKEND_ORIGIN}/api/files/${path}`;
export const createCheckout = (payload) => api.post("/payments/checkout", payload).then((r) => r.data);
export const getPaymentStatus = (sessionId) => api.get(`/payments/status/${sessionId}`).then((r) => r.data);

export const createShopifyCheckout = (payload) => api.post("/payments/shopify-checkout", payload).then((response) => response.data);

export const formatPrice = (n) =>
  new Intl.NumberFormat(getNumberLocale(), { style: "currency", currency: "TRY", maximumFractionDigits: 0 }).format(n);

export function formatApiError(err) {
  const data = err?.response?.data;
  const detail = data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (typeof data === "string" && data.includes("<")) return "İstek şu an tamamlanamadı, lütfen tekrar dene";
  return err?.message || "Bir sorun oluştu, tekrar dene";
}

export default api;

function getNumberLocale() {
  try { const locale = localStorage.getItem("shule-locale"); return ["tr", "en", "de", "ar", "fr", "es", "ru", "zh"].includes(locale) ? locale : "tr"; }
  catch { return "tr"; }
}
